<template>
    <div class="file-view-item" :class="{image : isImage, 'show-usage' : showTag, editable : editable, deletable : (deletable && !uploading), downloadable : downloadable, 'show-md5' : showMd5, 'changeable' : showMd5 }">
        <div class="file-name" v-if="isImage" @click="viewAsImg">
            <i class="file-icon file-type-icon" :class="fileTypeFn()"></i>
            <span class="name">{{ $fileName }}</span>
        </div>
        <div class="file-name" v-else-if="isViewableDoc" @click="viewAsDoc">
            <i class="file-icon file-type-icon" :class="fileTypeFn()"></i>
            <span class="name">{{ $fileName }}</span>
        </div>
        <div v-else class="file-name">
            <i class="file-icon file-type-icon" :class="fileTypeFn()"></i>
            <span class="name">{{ $fileName }}</span>
        </div>
        <div class="file-opera">
            <i v-if="isImage" class="viewable-icon icon iconfont icon-chakan" @click="viewAsImg"></i>
            <i v-else-if="isViewableDoc" class="viewable-icon icon iconfont icon-chakan" @click="viewAsDoc"></i>
            <i v-if="(downloadable && !isImage)" class="downloadable-icon icon iconfont icon-xiazai" @click="$download"></i>
            <i v-if="editable" class="editable-icon icon iconfont icon-bianji"></i>
            <i v-if="showMd5" class="md5-icon icon iconfont icon-md5" @click="$openMd5Page"></i>
            <i v-if="showMd5" class="changeable-icon icon iconfont icon-xiugaijilu2" @click="$showRepoFileBizRec"></i>
            <i v-if="deletable" class="delete-icon icon iconfont icon-shanchu1"></i>
        </div>
        <div v-if="uploading" class="progress" style="padding: 0; position: absolute;background: transparent;">
            <img v-resc-url="'/image/loading.gif'"/>
            <span>{{ uploadingProgress }}%</span>
        </div>
    </div>
</template>

<script>
    //show-usage image editable deletable
    import { Utils, $, H5file } from '../../app.base'
    import appConf from '../../app.conf';
    import { Vue } from '../../app.vues'
    //
    import { openRepoFileBizRecDlg } from './dialog';
    import { judgeFileType } from './Cmn'
    //
    //
    let fnGetUploadFileLimit = null;
    if(typeof getUploadFileLimit === 'function') {
        fnGetUploadFileLimit = getUploadFileLimit;
    }
    //
    let defaultUploadConfig = {
        serverUrl: '/file/upload',
        fileFor: null,
        accept: '*/*',
        fileGroup: 'file-misc',
        useMd5: true
    };

    export default {
        name: 'swb-file-item-li',
        desc: '文件上传',
        //
        props: {
            trackKey: {
                default: null
            },
            editable: {
                type: Boolean,
                default: false
            },
            deletable: {
                type: Boolean,
                default: false
            },
            downloadable: {
                type: Boolean,
                default: true
            },
            showTag: {
                type: Boolean,
                default: false
            },
            //
            tag: {
                type: String,
                default: null
            },
            //--------------
            fileUuid: {
                type: String,
                default: null
            },
            fileName: {
                type: String,
                default: null
            },
            fileBrowseUrl: {
                type: String,
                default: null
            },
            fileDownloadUrl: {
                type: String,
                default: null
            },
            fileMd5: {
                type: String,
                default: null
            },
            //--------------
            useMd5: {
                type: Boolean,
                default: false
            },
            //文件细分场景用途（本来应该在 uploadConfig 上设置，提到这里方便一些）
            fileFor: {
                type: String,
                default: null
            },
            //
            uploadConfig: {
                type: Object,
                default: function () {
                    return Utils.merge({}, defaultUploadConfig);
                }
            },
            //
            onDelete: {
                type: Function
            },
            onUploaded: {
                type: Function
            }
        },
        //
        data() {
            return {
                $fileUploader: null,
                uploading: false,
                uploadingProgress: 0,
                //
                fileInfo: {}
            }
        },
        //
        watch: {
            fileUuid(newValue, oldValue) {
                if(Utils.isNoB(newValue)) {
                    this.fileInfo = {};
                }
                //
                this.$set(this.fileInfo, 'fileUuid', newValue);
                if(oldValue) {
                    console.log('文件uuid已更新：' + oldValue + ' => ' + newValue);
                }
            },
            fileName(newValue, oldValue) {
                this.$set(this.fileInfo, 'fileName', newValue);
            },
            fileBrowseUrl(newValue, oldValue) {
                this.$set(this.fileInfo, 'fileBrowseUrl', newValue);
            },
            fileDownloadUrl(newValue, oldValue) {
                this.$set(this.fileInfo, 'fileDownloadUrl', newValue);
            },
            fileMd5(newValue, oldValue) {
                this.$set(this.fileInfo, 'fileMd5', newValue);
            }
        },
        //
        computed: {
            $fileUuid() {
                return this.fileInfo.fileUuid || this.fileUuid || null;
            },
            $fileName() {
                return this.fileInfo.fileName || this.fileName || null;
            },
            $fileBrowseUrl() {
                return this.fileInfo.fileBrowseUrl || this.fileBrowseUrl || null;
            },
            $fileDownloadUrl() {
                return this.fileInfo.fileDownloadUrl || this.fileDownloadUrl || null;
            },
            $fileMd5() {
                return this.fileInfo.fileMd5 || this.fileMd5 || null;
            },
            isImage() {
                return Utils.isImageFile(this.$fileBrowseUrl);
            },
            isViewableDoc() {
                return appConf.isViewableDocType(this.$fileBrowseUrl);
            },
            showMd5() {
                return !Utils.isNoB(this.$fileMd5);
            },
            $imageUrl() {
                if(this.isImage) {
                    return this.$fileBrowseUrl + '?' + new Date().getTime();
                }
                else {
                    return '';
                }
            }
        },
        //
        mounted() {
            let self = this;
            let parent = self.$parent || null;
            //
            let jqWrapper = $(this.$el);
            //
            if(this.deletable) {
                let proxyDeletor = jqWrapper.find('.delete-icon');
                this.proxyDeletor = proxyDeletor;
                //
                this._deleteHandler = function () {
                    if(self.onDelete) {
                        if(self.onDelete.call(parent, self.getFileInfo()) === false) {
                            return;
                        }
                        //销毁本组件
                        self.$destroy();
                    }
                    else {
                        console.warn('');
                    }
                };
                //
                proxyDeletor.bind('click', this._deleteHandler);
            }
            //
            if(this.editable) {
                let proxySelectBtn = jqWrapper.find('.file-opera .editable-icon');
                //
                let uploadConfig = Utils.merge({}, defaultUploadConfig);
                uploadConfig = Utils.merge(uploadConfig, this.uploadConfig);
                if(this.fileFor) {
                    //以自设的为先
                    uploadConfig.fileFor = this.fileFor;
                }
                //
                this.$fileUploader = H5file.Uploader.newOne();
                //
                this.$fileUploader.serverUrl(uploadConfig.serverUrl);
                this.$fileUploader.accept(uploadConfig.accept);
                //单文件
                this.$fileUploader.multiple(false);
                //
                this.$fileUploader.bindTo(proxySelectBtn);

                //
                this._fileChangeHanlder = function (fileItems, uploader) {
                    if(fileItems.length == 1) {
                        //直接上传
                        self.$fileUploader.upload();
                    }
                };
                this.$fileUploader.changeHandler(this._fileChangeHanlder);
                //
                let uploadFileLimit = null;
                if(fnGetUploadFileLimit != null) {
                    uploadFileLimit = fnGetUploadFileLimit(uploadConfig.fileFor) || null;
                }
                //
                this._beforeUpload = function (fileItems, uploader) {
                    self.uploading = false;
                    self.uploadingProgress = 0;
                    //
                    if(uploadFileLimit != null) {
                        let chkMsg = null;
                        if(fileItems.length > uploadFileLimit.count) {
                            chkMsg = "允许单次上传的文件数量为：" + uploadFileLimit.count + " 个";
                        }
                        else {
                            for(let i = 0; i < fileItems.length; i++) {
                                let fileItem = fileItems[i];
                                let fileSize = fileItem.size;
                                if(fileSize > uploadFileLimit.size) {
                                    chkMsg = "文件大小不能超过 " + uploadFileLimit.sizeStr;
                                    break;
                                }
                                let fileExt = Utils.extractFileNameExt(fileItem.name).toLowerCase();
                                if(!uploadFileLimit.exts.contains(fileExt)) {
                                    chkMsg = "允许的文件扩展名为：" + uploadFileLimit.exts.join(", ");
                                    break;
                                }
                            }
                        }
                        if(chkMsg != null) {
                            self.$alert(chkMsg, "提示", {
                                type: "warning",
                                closeOnClickModal: true
                            });
                            return false;
                        }
                    }
                    //
                    uploader.params({
                        whatFor: uploadConfig.fileFor || null,
                        group: uploadConfig.fileGroup || null,
                        update: !Utils.isNoB(self.$fileUuid),
                        useMd5: uploadConfig.useMd5,
                        uuid: self.$fileUuid || null
                    });
                };
                this.$fileUploader.beforeUpload(this._beforeUpload);
                //
                this._progressHandler = function (progress, uploader) {
                    self.uploading = true;
                    self.uploadingProgress = Math.floor((progress.loaded / progress.total) * 100);
                    //console.log(self.uploadingProgress);
                };
                this.$fileUploader.progressHandler(this._progressHandler);
                //
                this._uploadDone = function (result) {
                    self.uploading = false;
                    self.uploadingProgress = 0;
                    //
                    // console.log(result);
                    if(result.type == "info") {
                        let resultData = result.data;
                        //处理返回的文件信息
                        let files = resultData.files;
                        let file = files.first();

                        self.$updateFileInfo(file);
                        //
                        if(self.onUploaded) {
                            self.onUploaded.call(parent, self.getFileInfo(), self);
                        }
                    }
                    else {
                        let errMsg = result.message;
                        let resultData = result.data;
                        if(resultData != null && resultData.files) {
                            //处理返回的文件信息
                            let files = resultData.files;
                            let file = files.first() || null;
                            if(file != null) {
                                errMsg = file.message;
                            }
                        }
                        self.$alert(errMsg, "提示", {
                            type: "warning",
                            closeOnClickModal: true
                        });
                    }
                };
                this.$fileUploader.done(this._uploadDone);
                //
                this._uploadFail = function (result) {
                    self.uploading = false;
                    self.uploadingProgress = 0;
                    //
                    self.$alert(result.message, "提示", {
                        type: "warning",
                        closeOnClickModal: true
                    });
                };
                this.$fileUploader.fail(this._uploadFail);
                //
                this.$fileUploader.init();
            }
        },

        //
        beforeDestroy() {
            if(this.proxyDeletor != null) {
                this.proxyDeletor.unbind('click');
                //
                this.proxyDeletor = null;
            }
            //
            if(this.$fileUploader != null) {
                this.$fileUploader.destroy();
                //
                this.$fileUploader = null;
            }
        },
        //
        methods: {
            fileTypeFn() {
                return judgeFileType(this.$fileName, this.$fileBrowseUrl);
            },
            $download() {
                if(this.$fileDownloadUrl) {
                    Utils.downloadFile(getAppUrl("/file/download?uuid=" + this.fileUuid));
//                    Utils.setPageUrl(getAppUrl(this.$fileDownloadUrl), '_blank');
                }
            },
            viewAsImg() {
                if(this.$fileBrowseUrl) {
//                    if(typeof showImageViewBox == 'function'){
//                        //TODO 图片第一次弹出显示有问题
//                        //==> utils.js, jquery.js, jquery.colorbox.js, jquery.ext.js
//                        showImageViewBox(this.$fileBrowseUrl);
//                    }
//                    else {
//                        Utils.setPageUrl(this.$fileBrowseUrl, '_blank');
//                    }

                    Utils.setPageUrl(this.$fileBrowseUrl, '_blank');
                }
            },
            viewAsDoc() {
                if(this.$fileUuid) {
                    let docViewUrl = appConf.makeViewableDocUrl(this.$fileBrowseUrl, this.$fileUuid);
                    Utils.setPageUrl(docViewUrl, '_blank');
                }
            },
            $openMd5Page() {
                appConf.showFileMd5(this.$fileUuid);
            },
            $showRepoFileBizRec() {
                openRepoFileBizRecDlg(this.$fileUuid);
            },
            getFileInfo() {
                return Utils.merge({trackKey: this.trackKey, tag: this.tag}, this.fileInfo);
            },
            //
            $updateFileInfo(file) {
                let fileInfo = Utils.merge({}, this.fileInfo);
                fileInfo.fileName = file.fileName || file.fileDispName;
                fileInfo.fileUuid = file.fileUuid;
                fileInfo.fileBrowseUrl = file.fileBrowseUrl;
                fileInfo.fileDownloadUrl = file.fileDownloadUrl;
                fileInfo.fileExt = file.fileExtName;
                fileInfo.fileMd5 = file.fileMd5;
                //
                fileInfo.fileGroup = file.fileGroup;
                fileInfo.fileDeleteUrl = file.fileDeleteUrl;
                //
                this.fileInfo = fileInfo;
            }
        }

    }

</script>



// WEBPACK FOOTER //
// src/compo/ctrl/FileItemLi.vue